import React from 'react';
import ReactDOM from 'react-dom/client';
import './autoinsuranceinfoAddress.css';


function AutoInsuranceAddress({formData, handleChange}) {

  
    return (
      <div className="autoquoteinfo-address">
      <div className='autoquoteinfo-address-abc'>
        <div className='address-abc-a'>
          <p id='auto-address-abc-a'>A</p>
          <p id='auto-address-abc-address'>Address</p>
        </div>
        <div className='address-abc-b'>
          <p id='auto-address-abc-b'>B</p>
          <p id='auto-address-abc-birthdate'>Birthdate</p>
        </div>
        <div className='address-abc-c'>
          <p id='auto-address-abc-c'>C</p>
          <p id='auto-address-abc-contact'>Contact Info</p>
        </div>
      </div>
      <div className='addressinputs'>
      <input
        type="text"
        id="streetAddress"
        name="streetAddress"
        value={formData.streetAddress}
        onChange={(e) => handleChange('streetAddress', e.target.value)}
        placeholder='Street Address'
        required
      />
      <input
        type="text"
        id="state"
        name="state"
        value={formData.state}
        onChange={(e) => handleChange('state', e.target.value)}
        placeholder='State'
        required
      />
      <input
        type="text"
        id="zipCode"
        name="zipCode"
        value={formData.zipCode}
        onChange={(e) => handleChange('zipCode', e.target.value)}
        placeholder='Zip Code'
        required
      />
      </div>

      </div>
    );
  }
  
  export default AutoInsuranceAddress;